<template>
  <div
    class="modal"
    :class="{ 'modal--active' : isActive }"
    @click.self="closeModalAndEmit"
  >
    <div
      role="dialog"
      aria-modal="true"
      class="modal__dialog"
    >
      <div class="modal__content">
        <button
          class="button--close modal__close"
          @click="closeModalAndEmit"
        >
          <span class="icon--cross" />
        </button>

        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import './modal.scss'

import mixinFocusCapture from '../../mixins/mixin-focus-capture'
import mixinPopupCloseListeners from '../../mixins/mixin-popup-close-listeners'

export default {
  name: 'Modal',

  mixins: [
    mixinFocusCapture({toggleVariable: 'isActive', closeCallback: 'closeModal'}), 
    mixinPopupCloseListeners({closeCallback: 'closeModal', closeOnClickOutside: false})
  ],

  props: {
    id: {
      type: String,
      required: true
    },
    contentId: {
      type: String,
      default: ''
    },
    initActive: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isActive: this.initActive
    }
  },

  computed: {
    mixinTriggerId () {
      return `modal-trigger-${this.id}`
    }
  },

  mounted () {
    this.$eventHub.$on(`modal-close-${this.mixinTriggerId}`, this.closeModal)
    this.$eventHub.$on(`modal-open-${this.mixinTriggerId}`, this.openModal)
  },

  methods: {
    updateStore () {
      this.$store.dispatch('toggle/updateToggleState', { id: this.mixinTriggerId, isActive: this.isActive })
    },

    openModal () {
      this.isActive = true
    },

    closeModal () {
      this.isActive = false
    },

    closeModalAndEmit () {
      this.closeModal()
      this.$eventHub.$emit(`close-${this.contentId}`)
    },
  }
}
</script>